import { DEFAULT_PLATFORM_COLOR, KNOWN_PLATFORMS_STORAGE_KEY } from '@/lib/constants';
import type { KnownPlatform } from './platformTypes';

function normalizeKnownPlatform(item: unknown): KnownPlatform | undefined {
	if (!item || typeof item !== 'object') return undefined;

	const platform = item as Record<string, unknown>;
	if (typeof platform.subdomain !== 'string' || typeof platform.host !== 'string') return undefined;

	return {
		subdomain: platform.subdomain,
		host: platform.host,
		name: typeof platform.name === 'string' && platform.name ? platform.name : platform.host,
		logo: typeof platform.logo === 'string' ? platform.logo : '',
		primaryColor:
			typeof platform.primaryColor === 'string' && platform.primaryColor
				? platform.primaryColor
				: DEFAULT_PLATFORM_COLOR,
	};
}

export function readKnownPlatforms(): KnownPlatform[] {
	try {
		const value: unknown = JSON.parse(localStorage.getItem(KNOWN_PLATFORMS_STORAGE_KEY) || '[]');
		return Array.isArray(value)
			? value.flatMap((item) => {
					const platform = normalizeKnownPlatform(item);

					return platform ? [platform] : [];
				})
			: [];
	} catch {
		return [];
	}
}

export function saveKnownPlatforms(platforms: KnownPlatform[]) {
	localStorage.setItem(KNOWN_PLATFORMS_STORAGE_KEY, JSON.stringify(platforms));
}
